import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _toConsumableArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/usr/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect, useState } from "react";
import { useTranslation } from "@i18n";
import { CDN_LINK, SADAD_MAX_AMOUNT } from "@globalConfig";
import CheckedSVG from "../../../../SVGObjects/CheckedSVG";
import { copyTextToClipboard } from "@/utils/common";
import HowToPay from "@/_MiniApps/RemainingPaymentComponent/components/PaymentMethods/HowToPay/HowToPay";
import Loader from "@componentsShared/Loader/Loader";
import SharedPopUp from "@componentsShared/BottomSheetPopup__OLD/SharedPopUp";
import { api__addBankPayment, api__sendSadadInvoice } from "@/apis/checkout/sendSadadInvoice";
import useButtonLoading, { dispatchButtonLoading } from "@hooks/useButtonLoading";
import SubmitButton from "@componentsShared/buts/SubmitButton/SubmitButton";
import { If } from "@componentsShared/Conditional/If";
import VirtualIbanSection from "./VirtualIbanSection";
import BanksSections from "./BanksSections";
import { checkFeatureFlag } from "@/common/config/websiteConfig";
import BnplRemainingSection from "./BnplRemainingSection";
var PaymentMethods = function PaymentMethods(_ref) {
  var _order$remainingBnplO;
  var isFinance = _ref.isFinance,
    sadad = _ref.sadad,
    sadadError = _ref.sadadError,
    hasSadad = _ref.hasSadad,
    buttonLoading = _ref.buttonLoading,
    banks = _ref.banks,
    order = _ref.order,
    enableAllPayments = _ref.enableAllPayments,
    className = _ref.className,
    canSubmit = _ref.canSubmit,
    setCanSubmit = _ref.setCanSubmit,
    _ref$updateSadadError = _ref.updateSadadError,
    updateSadadError = _ref$updateSadadError === void 0 ? null : _ref$updateSadadError;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var _useState = useState(null),
    activeTab = _useState[0],
    setActiveTab = _useState[1];
  var _useState2 = useState(0),
    activeSadadTab = _useState2[0],
    setActiveSadadTab = _useState2[1];
  var _useState3 = useState({}),
    banksState = _useState3[0],
    setBanksState = _useState3[1];
  var _useState4 = useState(false),
    showPopUp = _useState4[0],
    setShowPopUp = _useState4[1];
  var _useState5 = useState(null),
    isCopySuccess = _useState5[0],
    setIsCopySuccess = _useState5[1];
  var _useState6 = useState(""),
    copySuccessText = _useState6[0],
    setCopySuccessText = _useState6[1];
  var _useState7 = useState(0),
    remainingAmount = _useState7[0],
    setRemainingAmount = _useState7[1];
  var _useState8 = useState((sadad === null || sadad === void 0 ? void 0 : sadad.invoices) || []),
    sadadInvoices = _useState8[0],
    setSadadInvoices = _useState8[1];
  var _useState9 = useState(false),
    localButtonLoading = _useState9[0],
    setLocalButtonLoading = _useState9[1];
  var setShowPopUpFunc = function setShowPopUpFunc(val) {
    return setShowPopUp(val);
  };
  var handleCopy = function handleCopy(e, i, isSadad) {
    if (window.isSecureContext) {
      copyTextToClipboard(e.target.previousElementSibling.innerText);
      if (isSadad) {
        setIsCopySuccess("sadad");
        setCopySuccessText("تم نسخ رقم الفاتورة");
      } else {
        setIsCopySuccess(i);
        setCopySuccessText(e.target.parentElement.previousSibling.innerText);
      }
      setTimeout(function () {
        setIsCopySuccess(null);
        setCopySuccessText("");
      }, 1000);
    }
  };
  var setSelectedFile = function setSelectedFile(bankName, value) {
    setBanksState(function (prevData) {
      return _objectSpread(_objectSpread({}, prevData), {}, _defineProperty({}, bankName, value));
    });
  };
  var removeSelectedFile = function removeSelectedFile(bankName) {
    setBanksState(function (prevData) {
      return _objectSpread(_objectSpread({}, prevData), {}, _defineProperty({}, bankName, null));
    });
  };
  var buttonLoadingState = useButtonLoading();
  var handleSubmit = function handleSubmit(banks) {
    if (buttonLoadingState) return;
    dispatchButtonLoading(true);
    var orderId = isFinance ? order === null || order === void 0 ? void 0 : order.order_id : order === null || order === void 0 ? void 0 : order.id;
    var isFinanceParam = isFinance ? 1 : 0;
    api__addBankPayment(orderId, banks, isFinanceParam).then(function () {
      location.reload();
    })["catch"](function () {
      dispatchButtonLoading(false);
    });
  };
  useEffect(function () {
    if (isFinance) {
      if (order && order.remaining_price) {
        setRemainingAmount(parseInt(order.remaining_price.replace(/,/g, "")));
      } else if (order && order.remaining_amount) {
        setRemainingAmount(parseInt(order.remaining_amount.replace(/,/g, "")));
      }
      setCanSubmit(Object.values(banksState).some(function (value) {
        return value;
      }));
    } else {
      if (order && order.remaining_price_payed) {
        setRemainingAmount(parseInt(order.remaining_price_payed.replace(/,/g, "")));
      } else if (order && order.remaining_amount) {
        setRemainingAmount(parseInt(order.remaining_amount.replace(/,/g, "")));
      }
      setCanSubmit(Object.values(banksState).some(function (value) {
        return value;
      }));
    }
  }, [order]);
  useEffect(function () {
    setCanSubmit(Object.values(banksState).some(function (value) {
      return value;
    }));
  }, [banksState]);
  var handleGenerateSadadLink = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(orderBody) {
      var data, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _context.p = 0;
            setLocalButtonLoading(true);
            _context.n = 1;
            return api__sendSadadInvoice(orderBody);
          case 1:
            data = _context.v;
            if (data === null) {
              updateSadadError && updateSadadError("Error");
            }
            setSadadInvoices(_toConsumableArray(data === null || data === void 0 ? void 0 : data.invoices));
            setLocalButtonLoading(false);
            _context.n = 3;
            break;
          case 2:
            _context.p = 2;
            _t = _context.v;
            updateSadadError && updateSadadError("Error");
            setLocalButtonLoading(false);
          case 3:
            return _context.a(2);
        }
      }, _callee, null, [[0, 2]]);
    }));
    return function handleGenerateSadadLink(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement("div", {
    className: "relative ".concat(className || "")
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    className: "text-[#0D0DB5] text-base font-bold leading-6 text-center"
  }, tShort("remaining/choose_payment_method", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-sm text-[#6C6C6C] mb-6 mt-3 leading-6 font-medium text-center"
  }, tShort("remaining/bank_transfer_note", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("ul", {
    className: "list-none p-0 m-0"
  }, hasSadad === true ? /*#__PURE__*/React.createElement("li", {
    className: ["flex flex-wrap justify-between items-center px-2 py-3 border border-gray-gainsboro border-solid rounded-lg relative mb-3", !enableAllPayments ? "pointer-events-none bg-[#e8eff6]" : "", activeTab === 0 ? "border-[#0D0DB5]" : ""].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between cursor-pointer flex-[100%]",
    onClick: function onClick() {
      return setActiveTab(activeTab === 0 ? -1 : 0);
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/paymentMethods/sadad.svg",
    alt: "sadad"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-[#00B362] text-xs leading-4 mr-auto ms-1 flex items-center"
  }, sadadInvoices !== null && sadadInvoices !== void 0 && sadadInvoices.some(function (invoice) {
    return invoice.invoiceStatus === "Pending";
  }) ? tShort("remaining/waiting_invoices", {
    ns: "web_tracking"
  }) : tShort("remaining/easiest_payment", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("img", {
    className: "transition-transform duration-300 ".concat(activeTab === 0 ? "rotate-180" : ""),
    src: CDN_LINK + "/assets/images/remaining-arrow.svg",
    alt: ""
  }))), activeTab === 0 && (buttonLoading || localButtonLoading ? /*#__PURE__*/React.createElement(Loader, {
    smallLoader: true
  }) : /*#__PURE__*/React.createElement("div", {
    className: "w-full"
  }, remainingAmount > 0 && remainingAmount < SADAD_MAX_AMOUNT && (sadadInvoices !== null && sadadInvoices !== void 0 && sadadInvoices.every(function (invoice) {
    return invoice.invoiceStatus === "Approved";
  }) || (sadadInvoices === null || sadadInvoices === void 0 ? void 0 : sadadInvoices.length) === 0) ? /*#__PURE__*/React.createElement("button", {
    className: "bg-[#0D0DB5] border-none text-white font-bold w-full h-12 rounded block mx-auto mt-6 mb-1 cursor-pointer",
    onClick: function onClick() {
      handleGenerateSadadLink({
        is_finance: isFinance ? 1 : 0,
        order_id: isFinance ? order === null || order === void 0 ? void 0 : order.order_id : order === null || order === void 0 ? void 0 : order.id
      });
    }
  }, tShort("remaining/create_invoice", {
    ns: "web_tracking"
  })) : (sadadInvoices === null || sadadInvoices === void 0 ? void 0 : sadadInvoices.length) > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "pt-8 mb-3"
  }, sadadInvoices.map(function (invoice, idx) {
    return /*#__PURE__*/React.createElement("div", {
      className: "rounded border border-[#d6dfe9] bg-white ".concat(idx > 0 ? "mt-3" : ""),
      key: idx
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between items-center p-4 pt-3 cursor-pointer ".concat(activeSadadTab === idx ? "[&_.sadadArrow]:rotate-180" : ""),
      onClick: function onClick() {
        return setActiveSadadTab(activeSadadTab === idx ? -1 : idx);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col items-start justify-center gap-1"
    }, /*#__PURE__*/React.createElement("p", {
      className: "text-[#6c7a8d] text-xs font-medium leading-4"
    }, tShort("remaining/invoice_amount", {
      ns: "web_tracking"
    })), /*#__PURE__*/React.createElement("strong", {
      className: "text-[#484848] text-sm font-semibold leading-4"
    }, invoice === null || invoice === void 0 ? void 0 : invoice.invoiceAmount, " ", /*#__PURE__*/React.createElement("span", null, tShort("remaining/sar", {
      ns: "web_tracking"
    })))), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-end gap-1"
    }, invoice.invoiceStatus === "Approved" && /*#__PURE__*/React.createElement(CheckedSVG, {
      filledColor: "#00B362"
    }), /*#__PURE__*/React.createElement("strong", {
      style: {
        color: invoice.invoiceStatus === "Approved" ? "#00B362" : "#FE561C"
      },
      className: "text-xs font-semibold leading-4"
    }, invoice.invoiceStatus === "Approved" ? tShort("remaining/invoice_paid", {
      ns: "web_tracking"
    }) : tShort("remaining/invoice_pending", {
      ns: "web_tracking"
    })), /*#__PURE__*/React.createElement("img", {
      className: "sadadArrow transition-transform duration-300 ".concat(activeSadadTab === idx ? "rotate-180" : ""),
      src: CDN_LINK + "/assets/images/remaining-arrow.svg",
      alt: ""
    }))), activeSadadTab === idx && /*#__PURE__*/React.createElement("div", {
      className: "p-4 pt-3 border-t border-[#d6dfe9]"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between items-center pt-1"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex-1"
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-xs leading-4 text-[#6c7a8d] font-semibold"
    }, tShort("remaining/invoice_number", {
      ns: "web_tracking"
    }), ":"), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center gap-2"
    }, /*#__PURE__*/React.createElement("strong", {
      className: "text-[#484848] text-xs font-bold leading-4"
    }, invoice.invoiceNumber), /*#__PURE__*/React.createElement("button", {
      onClick: function onClick(e) {
        return handleCopy(e, null, "sadad");
      },
      className: "cursor-pointer bg-transparent border-none text-[#0D0DB5] text-xs font-semibold leading-4 underline p-0"
    }, tShort("remaining/copy", {
      ns: "web_tracking"
    })))), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col flex-[0.4]"
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-xs leading-4 text-[#6c7a8d] font-semibold"
    }, tShort("remaining/biller_number", {
      ns: "web_tracking"
    }), ":"), /*#__PURE__*/React.createElement("strong", {
      className: "text-[#484848] text-xs font-bold leading-4"
    }, tShort(invoice.serviceType === "edaat" ? "remaining/edaat_903" : "remaining/gopay_902", {
      ns: "web_tracking"
    })))), /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between pt-4"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col gap-1 flex-1"
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-xs leading-4 text-[#6c7a8d] font-semibold"
    }, tShort("remaining/invoice_status", {
      ns: "web_tracking"
    })), /*#__PURE__*/React.createElement("strong", {
      style: {
        color: invoice.invoiceStatus === "Approved" ? "#00B362" : "#154F9C"
      },
      className: "text-xs font-bold leading-4"
    }, invoice.invoiceStatus === "Approved" ? tShort("remaining/invoice_paid", {
      ns: "web_tracking"
    }) : tShort("remaining/invoice_unpaid", {
      ns: "web_tracking"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col gap-1 flex-[0.4]"
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-xs leading-4 text-[#6c7a8d] font-semibold"
    }, tShort("remaining/expiry_date", {
      ns: "web_tracking"
    })), /*#__PURE__*/React.createElement("strong", {
      className: "text-[#484848] text-xs font-bold leading-4"
    }, invoice.invoiceExpiryDate)))));
  })) : /*#__PURE__*/React.createElement("div", {
    className: "flex-wrap border-[#0D0DB5]"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", {
    className: "text-[#0D0DB5] text-xs leading-4 mt-4 block"
  }, tShort("remaining/sadad_amount_exceeded", {
    ns: "web_tracking"
  })))), sadadError && /*#__PURE__*/React.createElement("div", {
    className: "text-center text-sm text-red-500 leading-6 mb-4"
  }, /*#__PURE__*/React.createElement("p", null, tShort("remaining/sorry", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("p", null, tShort("remaining/technical_error", {
    ns: "web_tracking"
  }))), /*#__PURE__*/React.createElement("button", {
    className: "bg-transparent border-none text-[#0D0DB5] underline mx-auto block cursor-pointer",
    onClick: function onClick() {
      return setShowPopUpFunc(true);
    }
  }, tShort("remaining/how_to_pay_title", {
    ns: "web_tracking"
  })), isCopySuccess === "sadad" && /*#__PURE__*/React.createElement("div", {
    className: "absolute left-0 top-0 w-full h-full flex justify-center"
  }, /*#__PURE__*/React.createElement("p", {
    className: "mt-[91px] min-w-[172px] w-fit h-min min-h-8 flex justify-center items-center bg-[rgba(108,122,141,0.75)] rounded-2xl text-white text-xs leading-8 px-3"
  }, copySuccessText))))) : null, /*#__PURE__*/React.createElement(If, {
    condition: !checkFeatureFlag("FF_VIRTUAL_IBAN")
  }, /*#__PURE__*/React.createElement(BanksSections, {
    banks: banks,
    banksState: banksState,
    setSelectedFile: setSelectedFile,
    removeSelectedFile: removeSelectedFile,
    enableAllPayments: enableAllPayments,
    order: order,
    activeTab: activeTab,
    setActiveTab: setActiveTab,
    isCopySuccess: isCopySuccess,
    copySuccessText: copySuccessText,
    handleCopy: handleCopy
  })), /*#__PURE__*/React.createElement(If, {
    condition: checkFeatureFlag("FF_VIRTUAL_IBAN")
  }, /*#__PURE__*/React.createElement(VirtualIbanSection, {
    isFinance: isFinance,
    order: order,
    activeTab: activeTab,
    setActiveTab: setActiveTab
  })), order === null || order === void 0 ? void 0 : (_order$remainingBnplO = order.remainingBnplOptions) === null || _order$remainingBnplO === void 0 ? void 0 : _order$remainingBnplO.map(function (option) {
    return /*#__PURE__*/React.createElement(BnplRemainingSection, {
      key: option.type,
      isFinance: isFinance,
      order: order,
      activeTab: activeTab,
      setActiveTab: setActiveTab,
      option: option
    });
  })), canSubmit && /*#__PURE__*/React.createElement("div", {
    className: "pt-12 flex justify-center items-center"
  }, /*#__PURE__*/React.createElement(SubmitButton, {
    type: "button",
    onClick: function onClick() {
      return handleSubmit(banksState);
    },
    loading: buttonLoadingState || buttonLoading,
    disabled: buttonLoadingState || buttonLoading
  }, tShort("remaining/submit", {
    ns: "web_tracking"
  })))), /*#__PURE__*/React.createElement(SharedPopUp, {
    show: showPopUp,
    onClose: function onClose() {
      return setShowPopUpFunc(false);
    }
  }, /*#__PURE__*/React.createElement(HowToPay, {
    onClose: function onClose() {
      document.body.style.overflow = "";
      setShowPopUpFunc(false);
    }
  })));
};
export default PaymentMethods;